// src/index.js
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import packageMetadata from '../package.json';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { AuthProvider } from './contexts/AuthContext';
import { CartProvider } from './contexts/CartContext';
import { ThemeProvider, useTheme } from './contexts/ThemeContext';
import PwaInstallPrompt from './components/PwaInstallPrompt';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';

document.documentElement.dataset.appVersion = packageMetadata.version;
console.info(`[App] Versão ${packageMetadata.version}`);

// 👇 ESTE COMPONENTE FALTAVA
function RootApp() {
  const { loadingTheme } = useTheme();

  useEffect(() => {
    if (!loadingTheme) {
      const splash = document.getElementById('splash');
      if (splash) splash.style.display = 'none';
    }
  }, [loadingTheme]);

  if (loadingTheme) return null;

  return <App />;
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <ThemeProvider>
      <PwaInstallPrompt />
      <AuthProvider>
        <CartProvider>
          <RootApp />
        </CartProvider>
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// Service Worker
serviceWorkerRegistration.register();

reportWebVitals();
